import PropTypes from 'prop-types';
import React from 'react';
import { ControlsWrapper, Button } from './ZoomControls.styled';

class ZoomControls extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (
      this.props.zoomed === nextProps.zoomed &&
      this.props.zoomIn === nextProps.zoomIn &&
      this.props.zoomOut === nextProps.zoomOut
    ) {
      return false;
    } else {
      return true;
    }
  }
  render() {
    return (
      <ControlsWrapper>
        <Button
          automationId="zoom-in-control"
          className={this.props.zoomed ? 'plus is-disabled' : 'plus'}
          onClick={this.props.zoomIn}
        >
          Zoom In
        </Button>
        <Button
          automationId="zoom-out-control"
          className={this.props.zoomed ? 'minus' : 'minus is-disabled'}
          onClick={this.props.zoomOut}
        >
          Zoom Out
        </Button>
      </ControlsWrapper>
    );
  }
}

ZoomControls.propTypes = {
  zoomIn: PropTypes.any,
  zoomOut: PropTypes.any,
  zoomed: PropTypes.any,
};

export default ZoomControls;
